import { MEDIA_POOL_SEARCH_MODES } from '../adjust/media-pool/constants';
import { getStoryMediaId } from './storyMediaItem';
import { STORY_ALTERNATIVE_SOURCE, STORY_MEDIA_SOURCE } from './storyMediaSources';

const LEGACY_SOURCE_MAP = {
  ACTIV8_CONTENT: STORY_MEDIA_SOURCE.ACTIV8,
  STUDIO_FAVORITE: STORY_MEDIA_SOURCE.FAVORITE,
};

function normalizeLegacySource(source) {
  return LEGACY_SOURCE_MAP[source] ?? source;
}

function resolveAlternativeSourceId(media) {
  return (
    media.sourceId ??
    media.id ??
    media.alternativeSearchParams?.activ8ContentId ??
    media.alternativeSearchParams?.favoriteId ??
    media.alternativeSearchParams?.uploadedId ??
    null
  );
}

function resolveAlternativeSource(media) {
  if (media.source) {
    return normalizeLegacySource(media.source);
  }

  if (media.alternativeSearchParams?.favoriteId) {
    return STORY_MEDIA_SOURCE.FAVORITE;
  }

  if (media.alternativeSearchParams?.uploadedId) {
    return STORY_MEDIA_SOURCE.UPLOADED;
  }

  return STORY_MEDIA_SOURCE.ACTIV8;
}

export function buildStoryScopeRequestFromMedia(media) {
  const source = resolveAlternativeSource(media);
  const sourceId = resolveAlternativeSourceId(media);

  switch (source) {
    case STORY_MEDIA_SOURCE.ACTIV8:
      return {
        source: STORY_ALTERNATIVE_SOURCE.ACTIV8_CONTENT,
        params: { activ8ContentId: sourceId },
      };
    case STORY_MEDIA_SOURCE.FAVORITE:
      return {
        source: STORY_ALTERNATIVE_SOURCE.STUDIO_FAVORITE,
        params: { favoriteId: sourceId },
      };
    case STORY_MEDIA_SOURCE.UPLOADED:
      return {
        source: STORY_ALTERNATIVE_SOURCE.UPLOADED,
        params: { uploadedId: sourceId },
      };
    default:
      return {
        source: STORY_ALTERNATIVE_SOURCE.ACTIV8_CONTENT,
        params: { activ8ContentId: sourceId },
      };
  }
}

export function buildAlternativeSearchRequest({ mode, media, message = '', query = '' }) {
  if (mode === MEDIA_POOL_SEARCH_MODES.SEARCH) {
    return {
      source: STORY_ALTERNATIVE_SOURCE.SEARCH,
      params: { query },
    };
  }

  if (mode === MEDIA_POOL_SEARCH_MODES.MESSAGE) {
    return {
      source: STORY_ALTERNATIVE_SOURCE.MESSAGE,
      params: { message },
    };
  }

  if (mode === MEDIA_POOL_SEARCH_MODES.MEDIA && media) {
    return buildStoryScopeRequestFromMedia(media);
  }

  if (media && getStoryMediaId(media)) {
    return buildStoryScopeRequestFromMedia(media);
  }

  return { source: mode, params: {} };
}
